// extracted by mini-css-extract-plugin
export var layoutContainer = "_3r-0";
export var layoutContainerOpen = "_3r-3";
export var mainContent = "_3r-1";
export var panelLarge = "_3r-6";
export var panelMedium = "_3r-5";
export var panelSmall = "_3r-4";
export var slidePanel = "_3r-2";